<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.5559 6.30587L17.6941 2.44412C17.516 2.266 17.2975 2.13537 17.06 2.06412V2H3.76C3.33962 2 3 2.33962 3 2.76V20.24C3 20.6604 3.33962 21 3.76 21H21.24C21.6604 21 22 20.6604 22 20.24V7.37937C22 6.97562 21.8409 6.59087 21.5559 6.30587ZM9.46 3.71H15.54V6.18H9.46V3.71ZM20.29 19.29H4.71V3.71H7.94V6.94C7.94 7.36037 8.27962 7.7 8.7 7.7H16.3C16.7204 7.7 17.06 7.36037 17.06 6.94V4.22775L20.29 7.45775V19.29ZM12.5 9.8375C10.6119 9.8375 9.08 11.3694 9.08 13.2575C9.08 15.1456 10.6119 16.6775 12.5 16.6775C14.3881 16.6775 15.92 15.1456 15.92 13.2575C15.92 11.3694 14.3881 9.8375 12.5 9.8375ZM12.5 15.1575C11.4502 15.1575 10.6 14.3072 10.6 13.2575C10.6 12.2077 11.4502 11.3575 12.5 11.3575C13.5497 11.3575 14.4 12.2077 14.4 13.2575C14.4 14.3072 13.5497 15.1575 12.5 15.1575Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGSave',
};
</script>

<style scoped>

</style>